import React, { useState } from 'react';
import { apis, hooks, models } from "@vote4dance/judging-sdk";
import { HeaderContainer, BodyContainer } from "../../../../base-react/components/Container";
import { App, Typography, Button, notification, Table, Select } from 'antd';
import { useParams } from "react-router-dom";
import { _T } from "../../../../base-react/src/Localization";
import { DeleteOutlined } from "@ant-design/icons";
var Api = apis.Api;
var Stream = hooks.streams.Stream;
var CompetitionUsersSource = models.users.CompetitionUsersSource;
var UserCompetitionItem = models.users.UserCompetitionItem;
var useSession = hooks.sessions.useSession;
var SessionState = hooks.sessions.SessionState;
import { SearchCompetitionUser } from '../../../components/SearchCompetitionUser';
import { useCompetition } from '../../../../base-react/hooks/Competition';
const { Title } = Typography;
const ADMINISTRATOR_LEVEL = 100;
export const EventUsers = () => {
    var _a;
    let { event_id } = useParams();
    const sessionState = useSession();
    const { modal } = App.useApp();
    const [, competitionEvent, , , , canEdit] = useCompetition(event_id);
    const competitionUsersSource = CompetitionUsersSource(event_id);
    const [items, loadingItems, errorItems] = Stream(competitionUsersSource);
    const [isLoading, setIsLoading] = useState();
    const isSystemAdministrator = SessionState.isSystemAdministrator(sessionState);
    const onAddItem = async (item) => {
        await Api.create(competitionUsersSource.url, item)
            .catch((err) => {
            notification.error({
                message: err.message
            });
        });
    };
    const onChangeLevel = async (text, item) => {
        setIsLoading(item.user_id);
        await Api.update(`${competitionUsersSource.url}/${item.usercompetition_id}`, {
            ...item,
            usercompetition_level: text
        })
            .catch((err) => {
            setIsLoading(undefined);
            notification.error({
                message: err.message
            });
        });
        setIsLoading(undefined);
    };
    const onDeleteItem = (item) => {
        modal.confirm({
            title: _T('common.delete.title', { name: _T('users.title').toLowerCase() }),
            content: _T('common.delete.content', { name: UserCompetitionItem.getFullName(item) }),
            onOk() {
                setIsLoading(item.user_id);
                Api.destroy(`${competitionUsersSource.url}/${item.usercompetition_id}`)
                    .then(() => {
                    //setIsLoading(undefined);
                })
                    .catch((err) => {
                    setIsLoading(undefined);
                    notification.error({
                        message: err.message
                    });
                });
            }
        });
    };
    const currentUserId = sessionState.userInfo.user_id;
    const isSessionCompetitionCreator = (competitionEvent === null || competitionEvent === void 0 ? void 0 : competitionEvent.competition_created_by) === currentUserId;
    const sessionUserLevelString = (_a = items === null || items === void 0 ? void 0 : items.find(a => a.user_id === currentUserId)) === null || _a === void 0 ? void 0 : _a.usercompetition_level;
    const sessionUserLevel = sessionUserLevelString ? parseInt(sessionUserLevelString, 10) : undefined;
    const effectiveSessionUserLevel = typeof sessionUserLevel === 'number'
        ? (isSessionCompetitionCreator && sessionUserLevel >= ADMINISTRATOR_LEVEL
            ? sessionUserLevel + 1
            : sessionUserLevel)
        : undefined;
    const columns = [
        {
            title: _T('users.name'),
            dataIndex: 'user_firstname',
            render: (user_firstname, user) => (UserCompetitionItem.getFullName(user))
        },
        {
            title: _T('users.email'),
            dataIndex: 'user_email',
            responsive: ['md'],
        },
        {
            title: _T('users.status'),
            dataIndex: 'usercompetition_level',
            render: (usercompetition_level, user) => (React.createElement(Select, { onChange: value => onChangeLevel(value, user), style: { width: 180 }, defaultValue: usercompetition_level.toString(), disabled: !canEdit || (!isSystemAdministrator && ((currentUserId === user.user_id) || (effectiveSessionUserLevel !== undefined ? effectiveSessionUserLevel <= parseInt(String(usercompetition_level), 10) : true))), loading: isLoading === user.user_id }, ['0', '10', '30', '50', '100'].map(level => React.createElement(Select.Option, { value: level, key: level, disabled: !isSystemAdministrator && (effectiveSessionUserLevel !== undefined ? effectiveSessionUserLevel < parseInt(level, 10) : true) }, _T('users.level.' + level + '.title')))))
        },
        {
            width: 20,
            render: (user) => (React.createElement(Button, { type: "text", icon: React.createElement(DeleteOutlined, null), onClick: () => onDeleteItem(user), disabled: !canEdit || (!isSystemAdministrator && ((currentUserId === user.user_id) || (effectiveSessionUserLevel !== undefined ? effectiveSessionUserLevel <= parseInt(String(user.usercompetition_level), 10) : true))), loading: isLoading === user.user_id }))
        },
    ];
    const footer = () => (React.createElement(SearchCompetitionUser, { event_id: event_id, callback: onAddItem, disabled: !canEdit }));
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderContainer, null,
            React.createElement(Typography, null,
                React.createElement(Title, null, _T('users.title')))),
        React.createElement(BodyContainer, null,
            React.createElement(Table, { size: "small", columns: columns, loading: loadingItems, rowKey: user => user.user_id, dataSource: items, pagination: false, footer: isSystemAdministrator || (effectiveSessionUserLevel !== undefined && effectiveSessionUserLevel >= ADMINISTRATOR_LEVEL) ? footer : undefined }))));
};
